/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorYoutube as ResolvedLabradorYoutube } from 'base/components/labrador/Youtube';

export const LabradorYoutube: typeof ResolvedLabradorYoutube = withLabradorInstanceof((props) => {
    return <ResolvedLabradorYoutube {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorYoutubeProps = PropsFromComponent<typeof LabradorYoutube>;
